import BorrowerOnboardingContent from './borrower-onboarding-content';

export default BorrowerOnboardingContent;
